import React, { useState, useEffect } from "react";
import { Col, Nav, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { AiFillFacebook, AiFillTwitterSquare } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";
import { CgInstagram } from "react-icons/cg";
import { GrGithub } from "react-icons/gr";
import "./style.css";
const NavBar = ({ color }) => {
  //navbar scroll when active state
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 60) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    window.addEventListener("scroll", changeBackground);
  });

  return (
    <Navbar
      id="hell"
      style={{ background: navbar ? "#f1f1f1" : "transparent" }}
      expand="lg"
      fixed="top"
    >
      <Container fluid>
        <Navbar.Brand href="#home">
          <div className={"gradient-text"}>Muhammad Umer Fareed</div>
        </Navbar.Brand>
        <div style={{ background: "var(--linear-bg1)", borderRadius: 10 }}>
          <Navbar.Toggle
            style={{
              background: "var(--linear-bg1)",
              borderWidth: 0,
              color: "var(--linear-bg1)",
            }}
            className="navToggleBtn"
            aria-controls="basic-navbar-nav"
          />
        </div>
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav style={{ marginTop: 15 }}>
            <Nav.Link href="#tab_1">
              <p className="textStyle"> Home</p>
            </Nav.Link>
            <Nav.Link href="#tab_2">
              <p className="textStyle"> Services</p>
            </Nav.Link>
            <Nav.Link href="#tab_3">
              <p className="textStyle">Portfolio</p>
            </Nav.Link>
            <Nav.Link href="#tab_4">
              <p className="textStyle">Technologies</p>
            </Nav.Link>
            <Nav.Link href="#tab_5">
              <p className="textStyle">Contact Me</p>
            </Nav.Link>
            <div className="socialIcon_Con">
              <Nav.Link
                className="socialIcon"
                href="https://www.facebook.com/Mianumerfareed"
                target="_blank"
              >
                <AiFillFacebook size={25} color={color || "white"} />
              </Nav.Link>
              <Nav.Link
                className="socialIcon"
                href="https://www.instagram.com/mianumerfareed/"
                target="_blank"
              >
                <CgInstagram size={25} color={color || "white"} />
              </Nav.Link>
              <Nav.Link
                className="socialIcon"
                href="https://www.linkedin.com/in/umer-fareed-%F0%9F%87%B5%F0%9F%87%B0-37b97a192/"
                target="_blank"
              >
                <AiFillTwitterSquare size={25} color={color || "white"} />
              </Nav.Link>

              <Nav.Link
                className="socialIcon"
                href="https://www.linkedin.com/in/umer-fareed-%F0%9F%87%B5%F0%9F%87%B0-37b97a192/"
                target="_blank"
              >
                <BsLinkedin size={25} color={color || "white"} />
              </Nav.Link>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
